__turbopack_context__.v({
  "appImage": "Prices-module__a2zQGq__appImage",
  "appImageContainer": "Prices-module__a2zQGq__appImageContainer",
  "appStoreButton": "Prices-module__a2zQGq__appStoreButton",
  "appStoreButtons": "Prices-module__a2zQGq__appStoreButtons",
  "buttonContent": "Prices-module__a2zQGq__buttonContent",
  "buttonIcon": "Prices-module__a2zQGq__buttonIcon",
  "buttonLargeText": "Prices-module__a2zQGq__buttonLargeText",
  "buttonSmallText": "Prices-module__a2zQGq__buttonSmallText",
  "buttonText": "Prices-module__a2zQGq__buttonText",
  "playStoreButton": "Prices-module__a2zQGq__playStoreButton",
  "prices": "Prices-module__a2zQGq__prices",
  "pricesCol": "Prices-module__a2zQGq__pricesCol",
  "pricesCopy": "Prices-module__a2zQGq__pricesCopy",
  "pricesCta": "Prices-module__a2zQGq__pricesCta",
  "pricesHeader": "Prices-module__a2zQGq__pricesHeader",
});
